export default "__VITE_ASSET__eaec4903__"